// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-management-modal {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 48px);
  max-width: 1170px !important;
}
.form-management-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  padding-top: 24px;
  padding-bottom: 24px;
}
.form-management-modal .modal-body {
  height: 100%;
  padding-right: 6px;
  position: relative;
  overflow-y: auto;
}
.form-management-modal .modal-body .search-input-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
}
.form-management-modal .modal-body .search-input-wrapper input {
  padding-right: 26px;
}
.form-management-modal .modal-body .search-input-wrapper .icon-search {
  width: 24px;
  height: 24px;
  top: 50%;
  right: 5px;
  display: inline-flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  transform: translateY(-50%);
  z-index: 1;
}
.form-management-modal .modal-body .filters {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  align-items: flex-start;
}
.form-management-modal .modal-body .filters-block {
  min-height: 68px;
  display: inline-flex;
  gap: 8px;
  position: relative;
  flex-direction: column;
  justify-content: flex-end;
}
.form-management-modal .modal-body .filters-block .label {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: var(--Secondary-eading, #101828);
}
.form-management-modal .modal-body .filters-block .filter {
  min-width: 210px;
  max-width: 210px;
  height: 40px;
  font-size: 14px;
}
.form-management-modal .modal-body .filters-block .filter .react-select-multi__multi-value__label {
  font-size: 14px;
}
.form-management-modal .modal-body .filters-block .react-datepicker__tab-loop {
  left: 0;
  top: 0;
  position: absolute;
}
.form-management-modal .modal-body .filters-block .clear-filters-btn {
  height: 44px;
  -webkit-user-select: none;
          user-select: none;
  color: var(--primary-500, #9e77ed);
  border: 1px solid var(--primary-500, #9e77ed);
}
.form-management-modal .modal-body .table-forms {
  margin-top: 24px;
}
.form-management-modal .modal-body .table-forms .table-wrapper {
  min-height: 128px;
  position: relative;
}
.form-management-modal .modal-body .table-forms .table-wrapper .tr:hover .table-row-actions {
  visibility: visible;
}
.form-management-modal .modal-body .table-forms .table-wrapper .tr.stopped {
  background-color: #f9fafb;
}
.form-management-modal .modal-body .table-forms .table-wrapper .tr .td {
  padding: 12px;
}
.form-management-modal .modal-body .table-forms .table-wrapper .tr .td:nth-child(n+2) {
  text-align: center;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions {
  width: 320px;
  display: inline-flex;
  gap: 16px;
  visibility: hidden;
  align-items: center;
  justify-content: flex-end;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .view-settings-button {
  padding-bottom: 2px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: var(--primary-500, #9e77ed);
  border-bottom: 1px solid var(--primary-500, #9e77ed);
  cursor: pointer;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .view-settings-button:hover {
  border-bottom-color: transparent;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .stop-initiation-button {
  height: 36px;
  display: inline-flex;
  gap: 8px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  -webkit-user-select: none;
          user-select: none;
  color: var(--tertiary-600, #B42318);
  border: 1px solid var(--secondary-input-outline, #FDA29B);
  cursor: pointer;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .stop-initiation-button:hover {
  color: #ffffff;
  background-color: var(--tertiary-600, #B42318);
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .stop-initiation-button:hover .icon-icon-x {
  border-color: #ffffff;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .stop-initiation-button .icon-icon-x {
  width: 16px;
  height: 16px;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tertiary-600, #B42318);
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .stop-initiation-button span {
  margin-top: -1px;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .delete-initiation-btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  border: 1px solid transparent;
  align-items: center;
  justify-content: center;
  background-color: #D92D20;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .delete-initiation-btn .icon-remove {
  font-size: 18px;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .delete-initiation-btn .icon-remove::before {
  color: #FFFFFF;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .delete-initiation-btn:hover {
  border-color: #D92D20;
  background-color: #FFFFFF;
}
.form-management-modal .modal-body .table-forms .table-wrapper .table-row-actions .delete-initiation-btn:hover .icon-remove::before {
  color: #D92D20;
}`, "",{"version":3,"sources":["webpack://./src/components/library/form-management-modal/styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;AACF;AACE;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACJ;AAEE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAAN;AAEM;EACE,mBAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;AADR;AAKI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAHN;AAKM;EACE,gBAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAHR;AAKQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AAHV;AAMQ;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAJV;AAMU;EACE,eAAA;AAJZ;AAQQ;EACE,OAAA;EACA,MAAA;EACA,kBAAA;AANV;AASQ;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kCAAA;EACA,6CAAA;AAPV;AAYI;EACE,gBAAA;AAVN;AAYM;EACE,iBAAA;EACA,kBAAA;AAVR;AAcY;EACE,mBAAA;AAZd;AAgBU;EACE,yBAAA;AAdZ;AAiBU;EACE,aAAA;AAfZ;AAiBY;EACE,kBAAA;AAfd;AAoBQ;EACE,YAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAlBV;AAoBU;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,oDAAA;EACA,eAAA;AAlBZ;AAoBY;EACE,gCAAA;AAlBd;AAsBU;EACE,YAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mCAAA;EACA,yDAAA;EACA,eAAA;AApBZ;AAsBY;EACE,cAAA;EACA,8CAAA;AApBd;AAsBc;EACE,qBAAA;AApBhB;AAwBY;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AAtBd;AAyBY;EACE,gBAAA;AAvBd;AA2BU;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAzBZ;AA2BY;EACE,eAAA;AAzBd;AA2Bc;EACE,cAAA;AAzBhB;AA6BY;EACE,qBAAA;EACA,yBAAA;AA3Bd;AA8BgB;EACE,cAAA;AA5BlB","sourcesContent":[".form-management-modal {\n  width: 100%;\n  height: 100%;\n  max-height: calc(100vh - 48px);\n  max-width: 1170px !important;\n\n  &-overlay {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n\n  .modal-body {\n    height: 100%;\n    padding-right: 6px;\n    position: relative;\n    overflow-y: auto;\n\n    .search-input-wrapper {\n      display: flex;\n      align-items: center;\n      position: relative;\n      justify-content: space-between;\n\n      input {\n        padding-right: 26px;\n      }\n\n      .icon-search {\n        width: 24px;\n        height: 24px;\n        top: 50%;\n        right: 5px;\n        display: inline-flex;\n        align-items: center;\n        position: absolute;\n        justify-content: center;\n        transform: translateY(-50%);\n        z-index: 1;\n      }\n    }\n\n    .filters {\n      display: flex;\n      gap: 16px;\n      margin-top: 16px;\n      align-items: flex-start;\n\n      &-block {\n        min-height: 68px;\n        display: inline-flex;\n        gap: 8px;\n        position: relative;\n        flex-direction: column;\n        justify-content: flex-end;\n\n        .label {\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 16px;\n          color: var(--Secondary-eading, #101828);\n        }\n\n        .filter {\n          min-width: 210px;\n          max-width: 210px;\n          height: 40px;\n          font-size: 14px;\n\n          .react-select-multi__multi-value__label {\n            font-size: 14px;\n          }\n        }\n\n        .react-datepicker__tab-loop {\n          left: 0;\n          top: 0;\n          position: absolute;\n        }\n\n        .clear-filters-btn {\n          height: 44px;\n          user-select: none;\n          color: var(--primary-500, #9e77ed);\n          border: 1px solid var(--primary-500, #9e77ed);\n        }\n      }\n    }\n\n    .table-forms {\n      margin-top: 24px;\n\n      .table-wrapper {\n        min-height: 128px;\n        position: relative;\n\n        .tr {\n          &:hover {\n            .table-row-actions {\n              visibility: visible;\n            }\n          }\n\n          &.stopped {\n            background-color: #f9fafb;\n          }\n\n          .td {\n            padding: 12px;\n\n            &:nth-child(n + 2) {\n              text-align: center;\n            }\n          }\n        }\n\n        .table-row-actions {\n          width: 320px;\n          display: inline-flex;\n          gap: 16px;\n          visibility: hidden;\n          align-items: center;\n          justify-content: flex-end;\n\n          .view-settings-button {\n            padding-bottom: 2px;\n            font-weight: 600;\n            font-size: 14px;\n            line-height: 24px;\n            color: var(--primary-500, #9e77ed);\n            border-bottom: 1px solid var(--primary-500, #9e77ed);\n            cursor: pointer;\n\n            &:hover {\n              border-bottom-color: transparent;\n            }\n          }\n\n          .stop-initiation-button {\n            height: 36px;\n            display: inline-flex;\n            gap: 8px;\n            padding: 0 10px;\n            font-size: 14px;\n            font-weight: 500;\n            border-radius: 8px;\n            align-items: center;\n            justify-content: center;\n            background-color: #fff;\n            user-select: none;\n            color: var(--tertiary-600, #B42318);\n            border: 1px solid var(--secondary-input-outline, #FDA29B);\n            cursor: pointer;\n\n            &:hover {\n              color: #ffffff;\n              background-color: var(--tertiary-600, #B42318);\n\n              .icon-icon-x {\n                border-color: #ffffff;\n              }\n            }\n\n            .icon-icon-x {\n              width: 16px;\n              height: 16px;\n              display: inline-flex;\n              font-size: 10px;\n              font-weight: 600;\n              border-radius: 50%;\n              align-items: center;\n              justify-content: center;\n              border: 1px solid var(--tertiary-600, #B42318);\n            }\n\n            span {\n              margin-top: -1px;\n            }\n          }\n\n          .delete-initiation-btn {\n            width: 36px;\n            height: 36px;\n            display: inline-flex;\n            border: 1px solid transparent;\n            align-items: center;\n            justify-content: center;\n            background-color: #D92D20;\n\n            .icon-remove {\n              font-size: 18px;\n\n              &::before {\n                color: #FFFFFF;\n              }\n            }\n\n            &:hover {\n              border-color: #D92D20;\n              background-color: #FFFFFF;\n\n              .icon-remove {\n                &::before {\n                  color: #D92D20;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
